import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { and, isArchivedFilter, or } from '../data'

interface PIICategoryParameterFormats {
  Format: string
  FormatEnable: string
  FormatExample: string
  FormatRegExp: string
  PID: number
  Title: string
  eKey?: string
  eTag?: string
}
interface PIICategoryParameterFormatsMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
  parentIdFilter: number
}
const LIST_NAME = 'PIICategoryParameterFormatsList'
const COLUMN_NAMES = {
  Format: 'Format',
  FormatEnable: 'FormatEnable',
  FormatExample: 'FormatExample',
  FormatRegExp: 'FormatRegExp',
  PID: 'PID',
  Title: 'Title',
  eKey: 'eKey',
  eTag: 'eTag',
}
const constructInquiryFilter = (args: PIICategoryParameterFormatsMetadataArgs): string => {
  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchivedFilter ?? null))

  if (args.parentIdFilter && args.parentIdFilter !== -1) {
    filters.push(`PID eq '${args.parentIdFilter}'`)
  }

  const filter = and(...filters)
  return filter
}
const getPIICategoryParameterFormatsListMetadata = async (
  args: PIICategoryParameterFormatsMetadataArgs
): Promise<PIICategoryParameterFormats[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructInquiryFilter(args)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.Title

  const items = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.Format,
      COLUMN_NAMES.FormatEnable,
      COLUMN_NAMES.FormatExample,
      COLUMN_NAMES.FormatRegExp,
      COLUMN_NAMES.PID,
      COLUMN_NAMES.Title,
      COLUMN_NAMES.eKey,
      COLUMN_NAMES.eTag
    )
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as PIICategoryParameterFormats[]
}
const addOrUpdatePIICategoryFormat = async (item) => {
  try {
    const list = await mpfRListsHttp().getList(LIST_NAME)
    const result = await list.addOrUpdateItem(item)
    return result
  } catch (error) {
    console.error('An error occurred while adding or updating the PII Category Format', error)
    throw new Error('Failed to add or update PII Category Format')
  }
}
const performBatch = async (batchOperation, listName, data) => {
  const batchItems:any = []

  const jsonResults = data || []
  jsonResults.forEach((result) => {
    const { Format, FormatEnable, FormatExample, FormatRegExp, PID, Title, eKey, eTag } = result
    const objectArray = createObjectArray(
      Format,
      FormatEnable,
      FormatExample,
      FormatRegExp,
      PID,
      Title,
      eKey,
      eTag
    )
    batchItems.push({
      data: objectArray,
      list: listName,
      op: batchOperation,
    })
  })
  await sendToServer(batchItems)

}

const createObjectArray = (
  format,
  formatEnable,
  formatExample,
  formatRegExp,
  PID,
  title,
  eKey,
  eTag
) => ({
  Format: format,
  FormatEnable: formatEnable,
  FormatExample: formatExample,
  FormatRegExp: formatRegExp,
  PID: PID,
  Title: title,
  eKey: eKey,
  eTag: eTag,
})
async function sendToServer(batchItems) {
  // Simulate async server request
  await mpfRListsHttp().createBatch(2, batchItems).execute()
}
async function sendBatchToServer(batchItems) {
  try {
      await performBatch(
        2,
        LIST_NAME,
        batchItems
      )
  } catch (error) {
    console.error('PII', error)
  }
}
export {
  COLUMN_NAMES,
  LIST_NAME,
  type PIICategoryParameterFormats,
  type PIICategoryParameterFormatsMetadataArgs,
  addOrUpdatePIICategoryFormat,
  getPIICategoryParameterFormatsListMetadata,
  sendBatchToServer,
}
